/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Selection } from './Selection';
import {
    SelectionFromJSON,
    SelectionFromJSONTyped,
    SelectionToJSON,
    SelectionToJSONTyped,
} from './Selection';

/**
 * 
 * @export
 * @interface BoxSplitOrderReqVo
 */
export interface BoxSplitOrderReqVo {
    /**
     * 来源订单ID
     * @type {number}
     * @memberof BoxSplitOrderReqVo
     */
    orderId?: number;
    /**
     * 候选查询返回的包装快照版本
     * @type {string}
     * @memberof BoxSplitOrderReqVo
     */
    packingVersion?: string;
    /**
     * 候选查询返回的订单商品版本
     * @type {string}
     * @memberof BoxSplitOrderReqVo
     */
    orderVersion?: string;
    /**
     * 整箱或箱内商品行选择，逐行全选仍为部分模式
     * @type {Array<Selection>}
     * @memberof BoxSplitOrderReqVo
     */
    selections?: Array<Selection>;
}

/**
 * Check if a given object implements the BoxSplitOrderReqVo interface.
 */
export function instanceOfBoxSplitOrderReqVo(value: object): value is BoxSplitOrderReqVo {
    return true;
}

export function BoxSplitOrderReqVoFromJSON(json: any): BoxSplitOrderReqVo {
    return BoxSplitOrderReqVoFromJSONTyped(json, false);
}

export function BoxSplitOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxSplitOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'packingVersion': json['packingVersion'] == null ? undefined : json['packingVersion'],
        'orderVersion': json['orderVersion'] == null ? undefined : json['orderVersion'],
        'selections': json['selections'] == null ? undefined : ((json['selections'] as Array<any>).map(SelectionFromJSON)),
    };
}

export function BoxSplitOrderReqVoToJSON(json: any): BoxSplitOrderReqVo {
    return BoxSplitOrderReqVoToJSONTyped(json, false);
}

export function BoxSplitOrderReqVoToJSONTyped(value?: BoxSplitOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'packingVersion': value['packingVersion'],
        'orderVersion': value['orderVersion'],
        'selections': value['selections'] == null ? undefined : ((value['selections'] as Array<any>).map(SelectionToJSON)),
    };
}

